import FormHandler from "global/js/Classes/FormHandler";

const businessBannerBtn = document.getElementById('businessModalBtn')
const businessSelect = document.getElementById('businessType')
const businessSelectLabel = businessSelect.nextElementSibling
let formArray = ['companyName', 'regon', 'name', 'phoneNumber', 'email', 'question']

new FormHandler(
    '/nt/form',
    'business-loans-form',
    formArray,
    7
)

businessSelect.addEventListener('change', function () {
    this.classList.remove('text-gray-800')
    this.classList.add('form-labeled')
    businessSelectLabel.classList.remove('d-none')

    if (this.value) {
        if(!formArray.includes('businessType')) {
            formArray.push('businessType')
        }
    }
})

businessBannerBtn.addEventListener('click', e => {
    e.preventDefault()
    $('businessLoansModal').modal('show')
})
